import React from 'react';
import { Button } from '../../components/ui/button';

/**
 * Dashboard top bar with title, free-tier note, and Upgrade-to-Pro CTA.
 */
const DashboardHeader = ({ isPro, onUpgradeClick }) => (
  <div className="mb-8 flex items-center justify-between gap-4 flex-wrap" data-testid="dashboard-header">
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-2">AI Stock Analysis</h1>
      <p className="text-gray-600 mb-2">Search for any stock to get comprehensive AI-powered analysis</p>
      {!isPro && (
        <p className="text-xs text-gray-500">
          Free plan: limited to 3 full analyses per day. Pro access is included with THE INCOME
          BLUEPRINT bundle — accounts are upgraded within 24 hours of purchase.
        </p>
      )}
    </div>
    {!isPro && (
      <div className="flex flex-col items-end gap-2">
        <Button
          type="button"
          className="bg-purple-600 hover:bg-purple-700 text-white text-sm"
          onClick={onUpgradeClick}
          data-testid="dashboard-upgrade-btn"
        >
          Get Pro Access
        </Button>
        <p className="text-[11px] text-gray-400">
          Buy THE INCOME BLUEPRINT on our Linktree, then submit your order email for a manual
          upgrade within 24 hours.
        </p>
      </div>
    )}
  </div>
);

export default DashboardHeader;
